import { render, staticRenderFns } from "./CVEditor.vue?vue&type=template&id=2b637c94&"
import script from "./CVEditor.vue?vue&type=script&lang=js&"
export * from "./CVEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports